import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { tipu, phoneticsBg } from "../../assets";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import TopBanner from "../../components/designTab/TopBanner";
import Bonus from "../../components/pageProps/Bonus";

const PhoneticsForeignAccent = () => {
  // ================ Course Module start here ==================
  const [showCourseMaterials, setShowCourseMaterials] = useState(true);
  const [showCourseFacilities, setShowCourseFacilities] = useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Phonetics - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Phonetics: Foreign Accent" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Introduction"
            des="Level up your English speaking, writing, and listening skills with us. Improve your English by memorizing the grammatical structures and vocabulary words of the affirmations. From the fundamental to the advanced levels, our expertise will help you advance your English learning to the point where you will never need to look back. Join us today for all of your English learning needs."
            instructorName="Mr. Masud Parvej Tipu"
            instructorTitle="Sr. Instructor, English"
            instructorImg={tipu}
            classTitle="Regular Class"
            classNo="24"
            langClubTitle="LANGUAGE CLUB"
            langClubNo="12"
            debate="Debate"
            supportTitle="SUPPORT"
            support="24/7"
            bg={phoneticsBg}
          />
          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why Phonetics course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  To keep pace with the world, there is no alternative to
                  learning Global English where pronunciation is an important
                  issue. And this pronunciation should be learned in the correct
                  way which is called Phonetics. Our course is for those who
                  want to understand foreigners or speak English like them or
                  with proper pronunciation.
                </p>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    English pronunciation skills will come.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    English Speaking skills will be improved.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    English Pronunciation skills will be improved.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Course materials Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseMaterials(!showCourseMaterials)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course materials / Learnings :
                {showCourseMaterials ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseMaterials && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        44 Phonetic Alphabets.
                      </li>
                      <li className="flex gap-2 items-start">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Contractions.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Intonation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Aspiration.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Assimilation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Word stress.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Sentence stress.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Connected speech.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        English Language Tags.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Tongue twister.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Course Facilities Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseFacilities(!showCourseFacilities)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course Facilities :
                {showCourseFacilities ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseFacilities && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        There is an opportunity to practice speaking in our
                        online club.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        We have an opportunity to practice writing directly on
                        this website.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="Language Club."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default PhoneticsForeignAccent;
